import Cookies from 'js-cookie'

/**
 * Static class for pushing events to the Google Tag Manager dataLayer.
 *
 * GTM is loaded server-side for authenticated members (Layouts/Head/_Meta.cshtml),
 * and after analytics consent for anonymous visitors (modules/cookieConsent.js).
 *
 * @namespace Analytics
 *
 * @example
 * import Analytics from 'lib/analytics'
 * Analytics.push('product_filter_select', { filter_category: 'Fresh Produce' })
 */
class Analytics {
	/**
	 * Whether analytics events may be collected for the current visitor
	 *
	 * @static
	 * @returns {boolean}
	 * @memberof Analytics
	 */
	static hasConsent() {
		const config = (window.LMC && window.LMC.cookieConsent) || {}

		// Authenticated members load GTM server-side, so there's no banner to gate on
		if (!(config.required === true || config.required === 'true')) return true

		// Global Privacy Control must be honored, same as cookieConsent.js
		if (typeof navigator !== 'undefined' && navigator.globalPrivacyControl === true) return false

		return Cookies.get(config.cookieName || 'lmc_cookie_consent') === (config.valueAnalytics || 'analytics')
	}

	/**
	 * Push a named event, and its parameters, to the dataLayer
	 *
	 * Dropped outright without consent. GTM processes the dataLayer from index 0 when it
	 * loads, so anything queued beforehand would be replayed if the visitor later accepts.
	 *
	 * @static
	 * @param {string} event The event name GTM triggers on
	 * @param {object} [params={}] Event parameters. Must be scalar to be reportable in GA4
	 * @memberof Analytics
	 */
	static push(event, params) {
		if (!event || !Analytics.hasConsent()) return

		window.dataLayer = window.dataLayer || []

		// event is assigned last so params can't clobber the name GTM triggers on
		window.dataLayer.push(Object.assign({}, params || {}, { event }))
	}
}

export default Analytics
